/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComplianceTimelineEventPayload } from './';
import {
    ComplianceTimelineEventPayloadFromJSON,
    ComplianceTimelineEventPayloadFromJSONTyped,
    ComplianceTimelineEventPayloadToJSON,
} from './';

/**
 * 
 * @export
 * @interface FraudReportEventTimelinePayload
 */
export interface FraudReportEventTimelinePayload extends ComplianceTimelineEventPayload {
    /**
     * 
     * @type {string}
     * @memberof FraudReportEventTimelinePayload
     */
    analyzeAlgorithm: string;
}

/**
 * Check if a given object implements the FraudReportEventTimelinePayload interface.
 */
export function instanceOfFraudReportEventTimelinePayload(value: object): value is FraudReportEventTimelinePayload {
    if (!('analyzeAlgorithm' in value) || value['analyzeAlgorithm'] === undefined) return false;
    return true;
}

export function FraudReportEventTimelinePayloadFromJSON(json: any): FraudReportEventTimelinePayload {
    return FraudReportEventTimelinePayloadFromJSONTyped(json, false);
}

export function FraudReportEventTimelinePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): FraudReportEventTimelinePayload {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadFromJSONTyped(json, ignoreDiscriminator),
        'analyzeAlgorithm': json['analyzeAlgorithm'],
    };
}

export function FraudReportEventTimelinePayloadToJSON(value?: FraudReportEventTimelinePayload | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadToJSON(value, true),
        'analyzeAlgorithm': value['analyzeAlgorithm'],
    };
}

